import React, { Component } from 'react';
import Step from '../step/step.component.js';

class OurMission extends Component {
	render() {
		const { title, description, image } = this.props.data;
		return (
			<section id="our-mission">
				<Step
					title={title}
					description={description}
					image={image}
					number={0}
				/>
			</section>
		);
	}
}

export default OurMission;
